import React, { forwardRef, useImperativeHandle, useState } from 'react';

const days = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const slots = [
  { key: 'morning', label: 'Morning' },
  { key: 'afternoon', label: 'Afternoon' },
  { key: 'evening', label: 'Evening' },
  { key: 'none', label: 'None' },
];

const Availability = forwardRef(({ newApplicant, setNewApplicant }, ref) => {
  const [errors, setErrors] = useState({});

  useImperativeHandle(ref, () => ({
    validateForm: () => {
      const newErrors = {};
      newApplicant.availability.forEach((dayObj) => {
        const selected = slots.some(({ key }) => !!dayObj[key]);
        if (!selected) {
          newErrors[dayObj.day] = 'Please select at least one option';
        }
      });
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    },
  }));

  const handleSlotChange = (day, slot) => {
    setNewApplicant((prev) => ({
      ...prev,
      availability: prev.availability.map((dayObj) =>
        dayObj.day === day ? { ...dayObj, [slot]: !dayObj[slot] } : dayObj
      ),
    }));
    setErrors((prev) => ({ ...prev, [day]: '' }));
  };

  return (
    <div className="space-y-6">
      <p className="text-md">
        Specify the times you are available for pickup and deliveries.
      </p>
      {days.map((day) => {
        const dayObj = newApplicant.availability.find((d) => d.day === day);
        return (
          <div key={day} className="mb-4">
            <div className="font-medium mb-2 capitalize">
              {day} <span className="text-red-500">*</span>
            </div>
            <div className="flex gap-2 flex-wrap">
              {slots.map(({ key, label }) => (
                <label
                  key={key}
                  className={`flex items-center border rounded-lg px-3 py-1 cursor-pointer text-sm ${
                    dayObj?.[key]
                      ? 'border-blue-500 bg-blue-50'
                      : 'border-gray-200 bg-white'
                  }`}>
                  <input
                    type="checkbox"
                    className={'form-checkbox mr-2'}
                    checked={!!dayObj?.[key]}
                    onChange={() => handleSlotChange(day, key)}
                  />
                  {label}
                </label>
              ))}
            </div>
            {errors[day] && (
              <div className="text-red-500 text-xs mt-1">{errors[day]}</div>
            )}
          </div>
        );
      })}
    </div>
  );
});

export default Availability;
